import { useEffect } from "react";
import { createContext,useState } from "react";

export const AuthContext = createContext()

const AuthProvider =({children}) =>{
  /*const [auth,setAuth] = useState(JSON.parse(localStorage.getItem("auth")) || false);*/
  const [globals, setGlobals] = useState(JSON.parse(localStorage.getItem("globals")) ||
    {
        auth: false,
        token: null,
        user: null,
        email:null,
        id: null,
        id_role: null,
        name_role:null,
        roles: {},
        companies: []
    }
  );

  useEffect(()=> {
    try{
      localStorage.setItem("globals", JSON.stringify(globals));
    }catch(error){
      localStorage.removeItem("globals");
      console.log(error);
    }
  },[globals])
  
  const contextValue = {
    globals,
    login(token,user,email,id,id_role,name_role,roles, companies){
      if(token !=null && user!=null && email!=null && id !=null && name_role != null){
        setGlobals(
          {
            auth: true,
            token: token,
            user: user,
            email: email,
            id: id,
            id_role: id_role,
            name_role: name_role,
            roles: roles,
            companies: companies
          }
        );
      }else{
        setGlobals(globals)
      }

    },
    logout(){
        setGlobals(
          {
            auth: false,
            token: null,
            user: null,
            email: null,
            id: null,
            id_role: null,
            name_role: null,
            roles: {},
            companies: []
          }
        );
    },
    isLogged(){
      return!!globals.auth;
    }
  }
  
  return(
    <AuthContext.Provider value={contextValue}>
      {children}
    </AuthContext.Provider>
  )
}


export default AuthProvider